import React from 'react';

import { useEffect } from 'react';
import { useState } from 'react';

import { useParams } from 'react-router-dom';

import { Accordion } from '../../components/Accordion';
import { Button } from '../../components/Button';
import { Footer } from '../../components/Footer';
import { Header } from '../../components/Header';
import { HeaderPage } from '../../components/HeaderPage';
import './style.css';

import FAQStore from '../../stores/FAQStore';

export const FaqDesktop = ({ shareFeedbackEmailAddress }) => {
	
	const { faqId } = useParams();
	
	let initialFaqStates = {};
	if(null != faqId){
		initialFaqStates[faqId] = true;
	}
	
	const [faqItemExpandedStates, setFaqItemExpandedStates] = useState(initialFaqStates);
	
    const store = FAQStore((state) => state);

    useEffect(() => {
        store.loadAll();
        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (null == store.faqItems) {
        return null;
    }

    return (
        <div className="FAQ-desktop">
            <div className="faq-desktop-container">
                <Header
                    className="header-instance"
                    style="desktop"
                    shareFeedbackEmailAddress={shareFeedbackEmailAddress}
                    logoDimensions={{
                        height: 64 * 1.8 + 'px',
                        width: 104 * 1.8 + 'px',
                    }}
                />
                <HeaderPage
                    align="left"
                    background="default"
                    breadcrumbLinkText="FAQ und Support"
                    breakpoint="desktop"
                    className="header-page-instance"
                    showSubtitle={false}
                    title="Suche nach Methoden, Erkenntnissen, Neuigkeiten"
                />
                <div className="section-search">
                    <div className="search-content">
                        <div className="search-input-container">
                            <div className="search-input-group">
                                <div className="search-input-wrapper">
                                    <input className="search-input" />
                                </div>
                                <Button
                                    className="search-button"
                                    status="default"
                                    style="default"
                                    textLink="Suche"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="results-section">
                    <div className="results-content">
                        <div className="results-heading">Ergebnisse</div>

                        <div className="faq-items-container">
                            {store.faqItems.length === 0 ? (
                                <p className="no-results-message">
                                    Currently no questions are available. Please
                                    check back a little later.
                                </p>
                            ) : null}

                            {store.faqItems.map((faqItem, i) => {
                                let expandedState =
                                    null != faqItemExpandedStates[faqItem.id] &&
                                    faqItemExpandedStates[faqItem.id]
                                        ? 'expanded'
                                        : 'collapsed';

                                return (
                                    <Accordion
                                        className="faq-accordion-item"
                                        img="/img/icon-3.svg"
                                        stateProp={expandedState}
                                        title={faqItem.title}
                                        content={
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: faqItem.htmlContent,
                                                }}
                                            ></div>
                                        }
                                        onClick={() => {
                                            let newState = JSON.parse(
                                                JSON.stringify(
                                                    faqItemExpandedStates,
                                                ),
                                            );

                                            newState[faqItem.id] =
                                                null == newState[faqItem.id]
                                                    ? true
                                                    : !newState[faqItem.id];

                                            setFaqItemExpandedStates(newState);
                                        }}
                                    />
                                );
                            })}
                        </div>

                        <div className="contact-cta-block">
                            <div
                                className="contact-cta-content-wrapper"
                                data-colors-mode="default"
                            >
                                <div className="contact-cta-inner-container">
                                    <div className="contact-content">
                                        <p className="contact-heading">
                                            Haben Sie eine Frage?
                                        </p>
                                        <div className="contact-text-container">
                                            <p className="contact-paragraph">
                                                <span className="paragraph-text">
                                                    Wir sind hier, um Ihnen zu
                                                    helfen! Haben Sie Fragen zur
                                                    DUO-Plattform oder benötigen
                                                    Sie Unterstützung? Zögern
                                                    Sie nicht, uns zu
                                                    kontaktieren. Unser
                                                    engagiertes Support-Team
                                                    steht Ihnen gerne zur
                                                    Verfügung, um Ihre Fragen zu
                                                    beantworten und Ihnen bei
                                                    Problemen zu helfen.
                                                    <br />
                                                </span>
                                            </p>
                                            <p className="contact-paragraph">
                                                <span className="paragraph-text">
                                                    Kontaktieren Sie uns über
                                                    das untenstehende Formular
                                                    oder senden Sie uns eine
                                                    E-Mail an [duo@tuecede.de].
                                                    Wir streben danach, Ihre
                                                    Anfragen so schnell wie
                                                    möglich zu beantworten und
                                                    sicherzustellen, dass Sie
                                                    die bestmögliche
                                                    Unterstützung erhalten.
                                                    <br />
                                                </span>
                                            </p>
                                            <p className="contact-paragraph">
                                                <span className="paragraph-text">
                                                    Vielen Dank für Ihr
                                                    Vertrauen. Wir freuen uns
                                                    darauf, von Ihnen zu hören
                                                    und Ihnen weiterzuhelfen!
                                                </span>
                                            </p>
                                        </div>
                                        <Button
                                            className="contact-button"
                                            status="default"
                                            style="secondary"
                                            textLink="Kontakt"
                                            onClick={(e) => {
                                                window.location =
                                                    'mailto:' +
                                                    shareFeedbackEmailAddress;
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer className="footer-component" property1="desktop" />
            </div>
        </div>
    );
};
